import {inject, Injectable} from '@angular/core';
import {CanActivateFn, GuardResult, MaybeAsync, Router} from '@angular/router';
import {UserRole} from '../../enums/user-role';
import {ROUTE_REDIRECTS_TOKEN} from '../../models/route-redirects';
import {AuthService} from './auth.service';

@Injectable()
export class ClientAuthGuard {

    public canActivate(): MaybeAsync<GuardResult> {
        return clientAuthGuard(undefined, undefined);
    }
}

export const clientAuthGuard: CanActivateFn = async () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const routeRedirects = inject(ROUTE_REDIRECTS_TOKEN);

    await authService.initAuthStatus();

    if (authService.userRole === UserRole.ADMIN) {
        const url = routeRedirects.DASHBOARD_ROUTES[UserRole.ADMIN];

        return router.parseUrl(url);
    }

    return true;
};
